export default "__VITE_ASSET__DvtQYh6y__"